
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-second-hand-clothes",
      function () {
        return require("private-next-pages/sell-second-hand-clothes/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-second-hand-clothes"])
      });
    }
  